import { ApiProperty } from '../../codegen';
import {
  IsBoolean,
  IsNumber,
  IsOptional,
  IsString,
  Min,
} from '../../validators';

export class BillingMaintenancePublicStatusDto {
  @ApiProperty()
  @IsBoolean({ groups: ['error'] })
  enabled: boolean;

  @ApiProperty({ required: false })
  @IsOptional({ groups: ['error'] })
  @IsString({ groups: ['error'] })
  message?: string;

  @ApiProperty({ required: false })
  @IsOptional({ groups: ['error'] })
  @IsNumber({}, { groups: ['error'] })
  @Min(0, { groups: ['error'] })
  updatedAtMs?: number;
}
